import React from 'react';
import { useDispatch } from 'react-redux';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  FormControl,
  Input,
  NativeSelect,
  Typography,
} from '@material-ui/core';

import { DropdownPayload } from '../types';
import { colorPalette } from '../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: '150px',
      color: 'black',
    },
    inputLabel: {
      color: 'inherit',
      fontSize: '1rem',
    },
    select: {
      color: 'inherit',
      backgroundColor: 'white',
      height: '2.5rem',
      borderRadius: theme.shape.borderRadius,
      transition: '0.2s linear',
      border: '2px solid #949494',
      '&:focus-within': {
        border: `2px solid ${colorPalette.lightBlue}`,
      },
      '&:hover': {
        backgroundColor: 'rgba(153,153,153,0.1)',
      },
    },
    selectRoot: {
      paddingLeft: '8px',
      '&:hover, &:focus, &:active': {
        backgroundColor: 'transparent',
      },
    },
  })
);

interface Props {
  actionCreator: ActionCreatorWithPayload<DropdownPayload, string>;
  dropdownName: string;
  label: string;
  options: string[];
  selectedOption: string;
  width: string;
}

const DropdownSelect = (props: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    dispatch(
      props.actionCreator({
        dropdownName: props.dropdownName,
        selectedOption: event.target.value as string,
      })
    );
  };
  return (
    <FormControl className={classes.formControl} style={{ width: props.width }}>
      <Typography align='left' color='inherit' variant='body1'>
        {props.label}
      </Typography>
      <NativeSelect
        className={classes.select}
        value={props.selectedOption}
        onChange={handleChange}
        id={props.label}
        classes={{ select: classes.selectRoot }}
        input={<Input disableUnderline={true} />}
      >
        {props.options.map((item: string) => {
          return (
            <option value={item} key={item}>
              {item}
            </option>
          );
        })}
      </NativeSelect>
    </FormControl>
  );
};

export default DropdownSelect;
